import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firebase-firestore";

class LinksDataService {
  db;

  constructor() {
    this.db = firebase.firestore();
  }

  getAll = () => {
    return this.db
      .collection("links")
      .get()
      .then((docList) => {
        let items = [];
        docList.docs.forEach((doc) => {
          // console.log(doc.data());
          items.push(doc.data());
        });
        return items;
      })
      .catch((error) => error);
  };

  create = async (links) => {
    const batch = this.db.batch();
    links.map((item) => {
      const collectionRef = this.db.collection("links").doc(item.source+"-"+item.target);
      batch.set(collectionRef, item);
    });

    await batch
      .commit()
      .then()
      .catch((error) => error);
  };

  delete = (linkIds) => {
    linkIds.map((id) => {
      return this.db
        .collection("links")
        .doc(id)
        .delete()
        .then()
        .catch((error) => error);
    });
  };
}

export default new LinksDataService();
